import { Controller } from "@hotwired/stimulus"

// 要素クリックで data-clipboard-text-value をクリップボードにコピーし、
// 直下に小さなトーストで「コピーしました」を 1.2 秒表示する。
//
// 使い方:
//   <span role="button" tabindex="0"
//         data-controller="clipboard"
//         data-clipboard-text-value="ABCD-1234"
//         data-action="click->clipboard#copy">ABCD-1234</span>
export default class extends Controller {
  static values = {
    text: String,
    label: { type: String, default: "コピーしました" },
  }

  async copy(event) {
    // 外側に <a> がある場合に親リンクのナビゲーションを抑止し、
    // Space キーのデフォルトのスクロールも止める。
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    const ok = await this.writeToClipboard(this.textValue)
    if (ok) this.showToast()
  }

  async writeToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch (err) {
        console.error("navigator.clipboard.writeText failed:", err)
      }
    }
    // 非セキュアコンテキスト等のフォールバック
    return this.legacyCopy(text)
  }

  legacyCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    let success = false
    try {
      success = document.execCommand("copy")
    } catch (err) {
      console.error("execCommand copy failed:", err)
    }
    textarea.remove()
    return success
  }

  showToast() {
    if (this.toast) this.toast.remove()
    this.toast = document.createElement("div")
    this.toast.textContent = this.labelValue
    this.toast.className =
      "fixed z-[9999] px-2 py-1 bg-[#0F2233] text-white text-[11px] rounded shadow pointer-events-none"
    document.body.appendChild(this.toast)

    const rect = this.element.getBoundingClientRect()
    this.toast.style.top = `${rect.bottom + 4}px`
    this.toast.style.left = `${rect.left}px`

    clearTimeout(this.hideTimer)
    this.hideTimer = setTimeout(() => this.hideToast(), 1200)
  }

  hideToast() {
    if (!this.toast) return
    this.toast.remove()
    this.toast = null
  }

  disconnect() {
    clearTimeout(this.hideTimer)
    this.hideToast()
  }
}
